import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { useState } from 'react'
import { Button, Container, Input, Loading, Textarea, Link } from 'components/ui'
import { useForm } from 'react-hook-form'
import { emailRegex, userNameRegex } from 'helpers/regex'
import { ContactService } from 'modules/contact/services'
import { useNotification } from 'hooks/use-notification'
import s from './contato.module.css'

export default function Contato() {
  const [loading, setLoading] = useState<boolean>(false)
  const { notify } = useNotification()

  const {
    register,
    handleSubmit,
    formState: { errors, touched, isSubmitting },
  } = useForm({
    mode: 'all',
  })

  const handleFormSubmit = async (data: any) => {
    setLoading(true)
    try {
      const contactService = new ContactService()
      await contactService.register({
        from: data.email,
        message: `Nome: ${data.name}\nTexto da mensagem: "${data.text}"`,
        subject: 'Sem assunto',
      })
      notify({
        type: 'success',
        title: 'Mensagem enviada',
        description: 'Recebemos sua mensagem, em breve entraremos em contato.',
      })
    } catch (e) {
      notify({
        type: 'danger',
        title: 'House um erro',
        description: 'Não foi possível enviar sua mensagem, tente novamente mais tarde.',
      })

      // TODO
      // Mostrar imagem na tela mostrando o e-mail, telefone etc para que o usuário entre em contato mesmo assim
    } finally {
      setLoading(false)
    }
  }

  const crums = [
    {
      label: 'contato',
    },
  ]

  return (
    <Layout>
      <Head>
        <title>Contato</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <Container className={s.root}>
        {loading && <Loading />}
        <h1 className={s.title}>Contato</h1>
        <div>
          Atendimento: <strong>Segunda à sexta das 9h às 18h</strong>
        </div>
        <div>
          WhatsApp:{' '}
          <Link href={`https://api.whatsapp.com/send?1=pt_br&phone=${process.env.NEXT_PUBLIC_WHATSAPP_NUMBER}`}>
            <strong>{process.env.NEXT_PUBLIC_WHATSAPP_NUMBER}</strong>
          </Link>
        </div>
        <form onSubmit={handleSubmit(handleFormSubmit)} className={s.form}>
          <Input
            type="text"
            name="name"
            placeholder="Nome"
            disabled={isSubmitting}
            error={errors?.name?.message}
            touched={touched?.name}
            maxLength={30}
            ref={register({
              required: {
                value: true,
                message: 'Por favor, preencha seu nome no campo acima',
              },
              pattern: {
                value: userNameRegex,
                message: 'Apenas letras é permitido',
              },
              minLength: {
                value: 5,
                message: 'Ao menos 5 (cinco) caracteres',
              },
            })}
          />
          <Input
            type="email"
            name="email"
            placeholder="E-mail"
            disabled={isSubmitting}
            error={errors?.email?.message}
            touched={touched?.email}
            ref={register({
              required: {
                value: true,
                message: 'Por favor, preencha seu e-mail',
              },
              pattern: {
                value: emailRegex,
                message: 'E-mail inválido',
              },
            })}
          />
          <Textarea
            name="text"
            placeholder="Sua mensagem"
            disabled={isSubmitting}
            error={errors?.text?.message}
            touched={touched?.text}
            rows={5}
            ref={register({
              required: {
                value: true,
                message: 'Por favor, preencha.',
              },
            })}
          />
          <Button variant="primary" type="submit" disabled={isSubmitting} loading={isSubmitting}>
            Enviar
          </Button>
        </form>
      </Container>
    </Layout>
  )
}
